import React from 'react';

import { HistoryOutlined } from '@ant-design/icons';
import { formatDateTime } from '@utils/dateTime';
import { Card, Empty, Tag, Timeline } from 'antd';
import { useTranslation } from 'react-i18next';

export default function POHistory({ histories }) {
  const { t } = useTranslation();

  const renderDescription = (item) => {
    if (item.fields_changed?.status) {
      const [from, to] = item.fields_changed.status;
      return (
        <span>
          {t(`enums.purchase_order.status.${from}`, { defaultValue: from })}
          {' → '}
          <Tag color="blue" style={{ marginLeft: 2 }}>
            {t(`enums.purchase_order.status.${to}`, { defaultValue: to })}
          </Tag>
        </span>
      );
    }
    const desc = item.description;
    if (desc && typeof desc === 'object' && desc.key) {
      const { key, ...interpolations } = desc;
      return t(`enums.purchase_order_history.action.${key}`, { defaultValue: key, ...interpolations });
    }
    return t(`enums.purchase_order_history.action.${item.action}`, { defaultValue: item.action });
  };

  return (
    <Card
      title={<><HistoryOutlined style={{ marginRight: 6 }} />{t('models.purchase_order.tabs.histories')} ({histories.length})</>}
      size="small"
    >
      {histories.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={false} />
      ) : (
        <Timeline
          items={histories.map((h) => ({
            key: h.id,
            children: (
              <div style={{ fontSize: 12 }}>
                <div>{renderDescription(h)}</div>
                <div style={{ color: '#999', fontSize: 11, marginTop: 2 }}>
                  {h.actor?.name && <span>{h.actor.name} · </span>}
                  {formatDateTime(h.created_at)}
                </div>
              </div>
            ),
          }))}
        />
      )}
    </Card>
  );
}
